<ng-container *ngIf="!errorGettingSettings; else settingsError">
  <div class="notifications-container" *ngIf="notificationSections; else loading">
    <div class="products">
      <ng-container *ngFor="let product of notificationSections">
        <div
          class="product"
          [ngClass]="{
            selected: selectedNotification.productId === product.productId
          }"
          (click)="selectNotification(product)"
        >
          <div class="icon" *ngIf="product.iconUrl">
            <img [src]="product.iconUrl" />
          </div>
          <div class="icon" *ngIf="product.iconType">
            <mat-icon>{{ product.iconType }}</mat-icon>
          </div>
          <div class="name">
            {{ product.name }}
          </div>
        </div>
      </ng-container>
    </div>
    <div class="notifications">
      <div class="options">
        <app-notification-settings
          [product]="selectedNotification"
          [accountGroupId]="accountGroupId"
          [subjectId]="subjectId"
          [disabledSections]="disabledSections"
        ></app-notification-settings>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <div class="loading">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
</ng-template>
<ng-template #settingsError>
  <div class="error-container">
    <div class="icon">
      <mat-icon>error</mat-icon>
    </div>
    <div class="message">
      {{ 'USER_NOTIFICATIONS.ERROR_GETTING_NOTIFICATION_SETTINGS' | translate }}
    </div>
  </div>
</ng-template>
